import React, { useEffect } from "react";
import { api_paths } from "../../config/api.paths";
import API from "../../config/axios";
import { useDispatch } from "react-redux";
import { SET_LOADING, SET_USER } from "../../redux/user/index";

const AppDataLoader = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("GSTB_token");
  const fetchUser = async () => {
    try {
      dispatch(SET_LOADING(true));
      const response = await API.get(api_paths.member.GET_USER);

      if (response.data?.payload?.result) {
        dispatch(SET_USER(response.data.payload.result));
      }
    } catch (error) {
      console.error("Failed to fetch user:", error);
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  useEffect(() => {
    if (token) {
      fetchUser();
    }
    // eslint-disable-next-line
  }, []);
  return <div></div>;
};

export default AppDataLoader;
